import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { ExportMetaContextType } from '../types/context.types';

const ExportMetaContext = createContext<ExportMetaContextType | undefined>(undefined);

export const useExportMeta = () => {
  const context = useContext(ExportMetaContext);
  if (!context) throw new Error('useExportMeta must be used within ExportProvider.');
  return context;
};

export const ExportMetaProvider = ({
  children,
  value
}: {
  children: ReactNode;
  value: ExportMetaContextType;
}) => {
  return <ExportMetaContext.Provider value={value}>{children}</ExportMetaContext.Provider>;
};
